import { AnimatePresence } from 'framer-motion';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { SidebarModal } from '../../../components';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import Spinner from '../../../components/common/Spinner';
import {
  dateDifferenceInDaysFromToday,
  globalPlans,
  wallets
} from '../../../helpers/helperFunctions';
import { WalletsType } from '../../../types/types';
import { PurchaseSteps } from '../Maeketplace.types';
import { purchasePackage } from '../Marketplace.actions';
import { Initial } from './Initial';
import { PayMixed } from './PayMixed';
import { PayTether } from './PayTether';
import { PaymentMethod } from './PaymentMethod';
import { Success } from './Success';

interface PurchasePackageAndComboProps {
  selectedPackage: any;
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
  userDiscountCodeId?: number | null;
  step: any;
  setStep: Dispatch<SetStateAction<any>>;
  setSelectedLicence: any;
  selectedLicence: any;
}

export const PurchasePackageAndCombo = ({
  selectedPackage,
  setModal,
  modal,
  step,
  setStep,
  setSelectedLicence,
  selectedLicence
}: PurchasePackageAndComboProps) => {
  const dispatch = useAppDispatch();
  const { addHubLoading } = useAppSelector((state) => state.marketplace);
  const { loading } = useAppSelector((state) => state.settings);
  const { userInfo } = useAppSelector((state) => state.auth);

  const [selectedNetwork, setSelectedNetwork] = useState<any>(wallets[0]);
  const [selectedToken, setSelectedToken] = useState<any>();

  const [lp, setLp] = useState('');
  const [club, setClub] = useState('');
  const [usdt, setUsdt] = useState('');
  const [usdc, setUsdc] = useState('');
  const [cash, setCash] = useState('');
  const [calculatedPrice, setCalculatedPrice] = useState('');

  const isRestrictedUser = userInfo.userType === 2;

  const licenceDate = dateDifferenceInDaysFromToday(
    userInfo.user.currentVirtualOfficeLicence?.dateEnd
  );

  useEffect(() => {
    setLp('');
    setCash('');
    setClub('');
    setUsdt('');
    setUsdc('');
    setSelectedToken('');
    setCalculatedPrice('');
  }, [modal, isRestrictedUser, selectedPackage]);

  const handlePayWithLicence = () => {
    dispatch(
      purchasePackage({
        packageId: selectedPackage.id,
        licenceId: selectedLicence?.id || null,
        currency: 'usdt',
        networkType: selectedNetwork.networkType,
        handleSuccess: () => setStep(PurchaseSteps.SUCCESS)
      })
    );
  };

  const handlePayWithoutLicence = () => {
    dispatch(
      purchasePackage({
        packageId: selectedPackage.id,
        licenceId: null,
        currency: 'usdt',
        networkType: selectedNetwork.networkType,
        handleSuccess: () => setStep(PurchaseSteps.SUCCESS)
      })
    );
  };

  const renderTitle = (step: number) => {
    if (step === PurchaseSteps.INITIAL) {
      if (licenceDate <= 30 && licenceDate > 0) {
        return 'Back Office Subscription';
      } else {
        return 'Purchase Entry Package';
      }
    } else if (step === PurchaseSteps.PAY_TETHER) {
      return 'PAYMENT DETAILS';
    }
  };

  return (
    <SidebarModal
      isOpen={modal}
      sidebarWidth={'650px'}
      setOpen={(v) => {
        setModal(v);
      }}
      title={renderTitle(step)}>
      <AnimatePresence exitBeforeEnter>
        {(loading || addHubLoading) && <Spinner absolute transparent />}

        {step === PurchaseSteps.INITIAL && (
          <AnimatedTab key={PurchaseSteps.INITIAL}>
            <Initial
              step={step}
              setStep={setStep}
              selectedPackage={selectedPackage}
              setModal={setModal}
              setSelectedLicence={setSelectedLicence}
              selectedLicence={selectedLicence}
              licenceDate={licenceDate}
              handlePayWithLicence={handlePayWithLicence}
              handlePayWithoutLicence={handlePayWithoutLicence}
            />
          </AnimatedTab>
        )}

        {/* {step === PurchaseSteps.PAYMENT_METHOD && (
          <AnimatedTab key={PurchaseSteps.PAYMENT_METHOD}>
            <PaymentMethod
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              setUsdt={setUsdt}
              setUsdc={setUsdc}
            />
          </AnimatedTab>
        )} */}

        {/* {step === PurchaseSteps.PAY_MIXED && (
          <AnimatedTab key={PurchaseSteps.PAY_MIXED}>
            <PayMixed
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              lp={lp}
              club={club}
              usdt={usdt}
              cash={cash}
              calculatedPrice={calculatedPrice}
              setLp={setLp}
              setClub={setClub}
              setCalculatedPrice={setCalculatedPrice}
              setCash={setCash}
              handlePay={handlePay}
            />
          </AnimatedTab>
        )} */}

        {step === PurchaseSteps.PAY_TETHER && (
          <AnimatedTab key={PurchaseSteps.PAY_TETHER}>
            <PayTether
              setStep={setStep}
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              selectedNetwork={selectedNetwork}
              selectedToken={selectedToken}
              setSelectedToken={setSelectedToken}
              setSelectedNetwork={setSelectedNetwork}
              setUsdt={setUsdt}
              setUsdc={setUsdc}
              lp={lp}
              club={club}
              cash={cash}
              calculatedPrice={calculatedPrice}
              handlePay={handlePayWithLicence}
            />
          </AnimatedTab>
        )}

        {step === PurchaseSteps.SUCCESS && (
          <AnimatedTab key={PurchaseSteps.SUCCESS}>
            <Success
              selectedPackage={selectedPackage}
              selectedLicence={selectedLicence}
              selectedNetwork={selectedNetwork}
              selectedToken={selectedToken}
              setSelectedNetwork={setSelectedNetwork}
              setSelectedToken={setSelectedToken}
            />
          </AnimatedTab>
        )}
      </AnimatePresence>
    </SidebarModal>
  );
};
